// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__yooSj","small":"Button_small__Q29P1","secondary":"Button_secondary__8lMmb"};